"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeliostatMirrorArray = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var MoonCard_1 = require("./MoonCard");
var HeliostatMirrorArray = (function (_super) {
    __extends(HeliostatMirrorArray, _super);
    function HeliostatMirrorArray() {
        return _super.call(this, {
            cost: 10,
            tags: [Tags_1.Tags.ENERGY],
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.HELIOSTAT_MIRROR_ARRAY,
            productionBox: Units_1.Units.of({ energy: 2 }),
            metadata: {
                description: 'Spend 1 titanium. Gain 1 heat. Increase your energy production 2 steps.',
                cardNumber: 'M41',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.minus().titanium(1).heat(1);
                    b.br;
                    b.production(function (pb) { return pb.energy(2); });
                }),
            },
        }, {
            reserveUnits: Units_1.Units.of({ titanium: 1 }),
        }) || this;
    }
    ;
    HeliostatMirrorArray.prototype.play = function (player) {
        _super.prototype.play.call(this, player);
        player.heat++;
        return undefined;
    };
    return HeliostatMirrorArray;
}(MoonCard_1.MoonCard));
exports.HeliostatMirrorArray = HeliostatMirrorArray;
//# sourceMappingURL=HeliostatMirrorArray.js.map